// extracted by mini-css-extract-plugin
export default {"container":"Overlay_container__-ZvuR","urgentLow":"Overlay_urgentLow__99gp+","normalRange":"Overlay_normalRange__IifHm","dexcomAttribution":"Overlay_dexcomAttribution__zlR06"};